import type { IdentifyResult, LngLat } from '@okmaps/shared';
import { baseApi } from './baseApi.js';

export interface IdentifyArgs {
  readonly layers: readonly string[];
  readonly point: LngLat;
  /** Current map scale denominator, so the proxy can size the pick tolerance. */
  readonly resolution: number;
}

/**
 * Feature identify, backed by WMS GetFeatureInfo.
 *
 * Upstream returns full geometry with every hit - a county query comes back as
 * a complete MultiPolygon just to show a name and a FIPS code. The proxy strips
 * geometry before it reaches us, which is the difference between a ~4 MB
 * response and a few hundred bytes.
 */
export const identifyApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    identify: build.query<readonly IdentifyResult[], IdentifyArgs>({
      query: ({ layers, point, resolution }) => ({
        url: 'identify',
        params: {
          layers: layers.join(','),
          lng: String(point.lng),
          lat: String(point.lat),
          resolution: String(resolution),
        },
      }),
      // Identify results are a point-in-time answer about a click. Holding them
      // past the interaction just serves stale attributes on the next click.
      keepUnusedDataFor: 30,
    }),
  }),
});

export const { useIdentifyQuery, useLazyIdentifyQuery } = identifyApi;
